import axios, { Method } from 'axios'
import qs from 'qs'
import config from './config'
import md5 from 'md5'
import { Toast } from 'antd-mobile'
import lxuilog from './lxuilog'
import common from './common'
import { getLoginInfo } from '../api/common'

const randomString = (len = 32) => {
    const defaultString = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' // 去掉了部分容易混淆的字符，参考了网上常用做法
    const maxLen = defaultString.length
    let _randomStr = ''
    for (let i = 0; i < len; i++) {
        _randomStr += defaultString[Math.floor(Math.random() * maxLen)]
    }
    return _randomStr
}


const __axios: any = axios.create()

__axios.defaults.timeout = 30000;

__axios.defaults.retry = 1; //token失效 默认最大重复请求次数

let failRequests = []; // 因为token失败的请求，后续补上
let isTokenExpire = false; // token是否过期
let isFetchNewToken = false; // 是否发起了新token的请求

// 正在请求的接口对象
const pending: any = {}

// 取消正在等待的请求
interface PendingConfig {
    url: string // 请求地址
    method: string // 请求类型
}
const cancelPending = (config: PendingConfig) => {
    if (pending[name]) {
        pending[name]()
        delete pending[name]
    }
}

// 添加请求拦截器
__axios.interceptors.request.use(async(config: any) => {
    // cancelPending(config)
    let userInfo = window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : {}
    //安卓
    if( !common?.isAndroid_ios() ) {
        if (window?.androidNative?.getUserInfo) {
            const _userInfo = window?.androidNative?.getUserInfo()
            if (_userInfo) {
                window.localStorage.setItem('userInfo', _userInfo)
                userInfo = JSON.parse(_userInfo)
            }
        }
    }else {
        //ios
        userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    }
    // 获取最新的登录信息
    // if ( !config.url.includes('/yme-auth/oauth/getLoginInfo') && userInfo?.pk) {
    //     try {
    //         const res:any = await getLoginInfo(userInfo?.pk)
    //         userInfo = res?.data
    //         window.localStorage.setItem('userInfo', JSON.stringify(res?.data))
    //     } catch (error) {
            
    //     }
    // }
    
    const authorization = `${userInfo?.tokenHead || ''}${userInfo?.authorization || ''}`

    // if( config.url.endsWith('oauth/getLoginInfo') ) {
    //     console.log(authorization)
    //     console.log(config?.url)

    // }

    // 张总 线上登录信息
    // const authorization = `29bc7c13212a4d582390065082fdd8d6ac0e9478875811daa1da261d75df0f52cfcd208495d565ef66e7dff9f98764da`
    if( !!authorization ) {
        config.headers['Authorization'] = authorization || ''
    }

    // if (process.env.NODE_ENV === 'development') {
    //     if (isTokenExpire && !config.url.endsWith('/yme-auth/sysLogin/loginByPassword')) {
    //         failRequests.push(config)
    //         return
    //     }
    //     let devToken = ''
    //     try {
    //         devToken = localStorage.getItem('devToken')
    //     } catch (err) {

    //     }
    //     config.headers['Authorization'] = `Bearer 9A122E219C3741C9A597E89334950EB2`
    // } else {
    //     const authorization = `${userInfo?.tokenHead}${userInfo?.authorization}`
    //     config.headers['Authorization'] = authorization
    // }
    /**
     * 支付加密: 时间戳 随机字符串 排序 md5转大写
     */
    const timestamp = +new Date()
    const noncestr = randomString()
    const options = {
        ...config.data
    }

    const optionsList = Object.keys(options).sort()
    const sign = md5(optionsList.reduce((total, current) => `${total}${current}${options[current]}`, '') + `noncestr${noncestr}` + `timestamp${timestamp}keyWdxvZ$EYN!Bc6%7KuQ8VizOR8MXGFmqq`).toLocaleUpperCase()

    config.headers['timestamp'] = timestamp
    config.headers['noncestr'] = noncestr
    config.headers['sign'] = sign
    
    if (config.contentType === 'form') {
        config.data = qs.stringify(config.data, { arrayFormat: 'indices', allowDots: true })
    } else if (config.contentType === 'json') {
        config.data = JSON.stringify(config.data)
    }
    return config
}, error => {
    if (config.env === 'dev') {
        console.log(error)
    }
    return Promise.reject(error)
})

// token失效重新请求
const againRequest = async (response) => {
    try {
        let _config = response.config
        if (!_config || !_config.retry) {
            return Promise.reject(response.data)
        }
        // 初始化重新请求的次数
        _config.__retryCount = _config.__retryCount || 0;

        // 请求超过默认的次数就不在请求
        if (_config.__retryCount >= _config.retry) {
            // 超过最大请求次数 请登录信息失效 跳转登录
            if (response?.data?.code === 'E000012') {
                Toast.show({
                    content: `登录状态过期!`,
                    position: 'bottom'
                })
                if (window?.androidNative?.tokenInvalid) {
                    window.androidNative.tokenInvalid()
                }
            }
            return Promise.reject(response.data)
        }
        // 重新请求次数+1
        _config.__retryCount += 1;
        /**
         * 刷新token 缓存window.localStorage.getItem('userInfo')起来 在重新请求
         */
        const res: any = await __axios(_config)
        if (res?.data?.code === 'E000012') {
            againRequest(res)
        }
    } catch (error) {
        console.log(error)
    }
}

// 开发环境, 获取新的token
const getNewToken = async () => {
    try {
        const res = await postJSON('/yme-auth/sysLogin/loginByPassword', {
            username: "13434450121",
            password: "123456",
            grant_type: "password",
            verificationCode: ""
        })
        localStorage.setItem('devToken', res.data.authorization)
        isTokenExpire = false
        isFetchNewToken = false
        for (let i = 0; i < failRequests.length; i++) {
            __axios(failRequests[i])
        }
        failRequests = []
    } catch (err) {
        isFetchNewToken = false
        console.log(err)
    }
}

// 添加响应拦截器
__axios.interceptors.response.use((response: any) => {
    // cancelPending(response.config)
    if (process.env.NODE_ENV === 'development') {
        // if(response.data?.code === 'E000012') {
        //     // 登录信息过期
        //     isTokenExpire = true
        //     if(!isFetchNewToken) {
        //         isFetchNewToken = true
        //         getNewToken()
        //     }
        //     failRequests.push(response.config)
        // }
    }
    return response
}, async error => {
    // console.log(error.response.status)
    // cancelPending(response.config)
    if (process.env.NODE_ENV === 'development') {
        // if(error?.response?.code === 'E000012') {
        //     // 登录信息过期
        //     isTokenExpire = true
        //     if(!isFetchNewToken) {
        //         isFetchNewToken = true
        //         getNewToken()
        //     }
        //     failRequests.push(error.response.config)
        // }
    }
    try {
        if (config.env === 'dev') {
            console.log(error)
        }
        return Promise.reject(error.response)
    } catch (error) {
        return Promise.reject(error.response)
    }
})


// 定义Axios请求返回的类型
export interface AxiosResolveData {
    code: number // 状态码
    data: any // 数据对象
    errorCode?: string // 错误提示
    msg?: string // 提示信息
    rows?: unknown[] // 分页才有，列表数据
    total?: number // 分页才有，总记录数
}

/**
 * axios请求
 * @param url 请求地址
 * @param options 请求参数
 * @param axiosConfig axios配置信息
 * @param method 请求类型
 * @param contentType 传输数据类型
 * @param isShowMsg 是否提示错误信息
 * @param errCallback 错误的回调方法
 */

const _axios = (url: string, options: any, axiosConfig = {}, method: Method = 'POST', contentType = 'form', isShowMsg = true, async = true, errCallback = () => { }) => {
    return new Promise((resolve: (value: AxiosResolveData) => void, reject) => {
        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Cache-Control': 'no-cache'
        }
        if (contentType === 'json') {
            headers['Content-Type'] = 'application/json'
        }
        const _url = (url.includes('yme-gewe') ||  url.includes('yme-facility') || url.includes('yme-agency') || url.includes('yme-system') || url.includes('yme-wxmp') || url.includes('yme-auth') || url.includes('payApi')) ? url : `${config.server}${url}`
        __axios({
            method,
            ...axiosConfig,
            url: _url,
            headers,
            contentType,
            async,
            [(method === 'GET' || method === 'DELETE') ? 'params' : 'data']: {
                ...options
            },
            transformResponse: [(data) => {
                const _data = JSON.parse(data)
                if (_data.status) {
                    return {
                        ..._data,
                        errCallback
                    }
                }
                return _data
            }]
        }).then(data => {
            if (data?.data?.code === '00' || data?.data?.success) {
                resolve(data?.data)
            } else if (data?.data?.code === 'E000012') {

                if( !!window?.androidNative?.tokenInvalid ) {
                    Toast.show({
                        content:`登录状态过期!`,
                        position: 'bottom'
                    })
                    // window?.androidNative?.tokenInvalid()
                }
                if (process.env.NODE_ENV === 'development') {
                    // againRequest(data)
                }
                reject('登录状态过期!')
            } else {
                reject(data?.data)
                if (data?.data?.msg && isShowMsg) {
                    Toast.show({
                        content: `${data?.data?.msg}`,
                        position: 'bottom',
                    })
                }
                // if( process.env.NODE_ENV === 'development' ) {
                //     if( data?.data?.msg && isShowMsg) {
                //         Toast.show({
                //             content:`${data?.data?.msg}`,
                //             position: 'bottom',
                //         })
                //     }
                // }
            }
        }).catch(data => {
            if (config.env === 'dev') {
                console.log(data.data)
            }
            if ( !!data?.data?.msg && isShowMsg) {
                Toast.show({
                    content: `${data?.data?.msg}`,
                    position: 'bottom',
                })
            }
            reject(data)
        })
    })
}

export default _axios

/**
 * get 请求
 */
export const get = (url: string, options?: object, axiosConfig?: object, isShowMsg = true) => _axios(url, options, axiosConfig, 'GET', null, isShowMsg)

/**
 * post 请求 form 类型
 */
export const post = (url: string, options?: object, axiosConfig?: object, isShowMsg = true) => _axios(url, options, axiosConfig, 'POST', 'form', isShowMsg)

/**
 * post 请求 json 类型
 */
export const postJSON = (url: string, options?: object, axiosConfig?: object, isShowMsg = true, async = true) => _axios(url, options, axiosConfig, 'POST', 'json', isShowMsg, async)

/**
 * delete 请求 form 类型
 */
export const del = (url: string, options?: object, axiosConfig?: object, isShowMsg = true) => _axios(url, options, axiosConfig, 'DELETE', 'form', isShowMsg)

/**
 * delet 请求 json 类型
 */
export const delJSON = (url: string, options?: object, axiosConfig?: object) => _axios(url, options, axiosConfig, 'DELETE', 'json')

/**
 * put 请求 form 类型
 */
export const put = (url: string, options?: object, axiosConfig?: object) => _axios(url, options, axiosConfig, 'PUT', 'form')

/**
 * put 请求 json 类型
 */
export const putJSON = (url: string, options?: object, axiosConfig?: object) => _axios(url, options, axiosConfig, 'PUT', 'json')


